import type { LinkProps as MuiLinkProps } from '@mui/material/Link';
import MuiLink from '@mui/material/Link';
import React from 'react';

type Props = Omit<
  MuiLinkProps<'button'>,
  'component' | 'href' | 'type' | 'onClick'
> & {
  onClick: React.MouseEventHandler<HTMLButtonElement>;
};

/**
 * An action inside a text, e.g. in a message: a button that looks like a
 * link and takes the font of the text around it. Use `Link` to navigate.
 */
const LinkButton = React.forwardRef<HTMLButtonElement, Props>(
  ({ sx, ...props }, ref) => (
    <MuiLink
      ref={ref}
      component="button"
      type="button"
      {...props}
      sx={[
        { font: 'inherit', verticalAlign: 'baseline' },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    />
  ),
);

LinkButton.displayName = 'LinkButton';
export default LinkButton;
